import { __decorate } from "tslib";
import { html, LitElement } from 'lit';
import { property, query } from 'lit/decorators.js';
import { ifDefined } from 'lit/directives/if-defined.js';
import { emit, waitForEvent } from '../../internal/event.js';
import { watch } from '../../internal/watch.js';
import { ARC_EVENTS } from '../../internal/constants/eventConstants.js';
import { ICON_TYPES } from '../icon/constants/IconConstants.js';
import styles from './arc-sidebar.styles.js';
import '../icon-button/arc-icon-button.js';
export default class ArcSidebar extends LitElement {
    constructor() {
        super(...arguments);
        this.open = true;
    }
    async handleOpenChange() {
        if (this.open) {
            emit(this, ARC_EVENTS.show);
            emit(this, ARC_EVENTS.afterShow);
        }
        else {
            emit(this, ARC_EVENTS.hide);
            emit(this, ARC_EVENTS.afterHide);
        }
    }
    show() {
        if (this.open) {
            return undefined;
        }
        this.open = true;
        return waitForEvent(this, ARC_EVENTS.afterShow);
    }
    hide() {
        if (!this.open) {
            return undefined;
        }
        this.open = false;
        return waitForEvent(this, ARC_EVENTS.afterHide);
    }
    _handleClick() {
        if (this.open) {
            this.hide();
        }
        else {
            this.show();
        }
    }
    handleSlots(e) {
        const childNodes = e.target.assignedElements({ flatten: true });
        if (childNodes.length > 1) {
            this.content.classList.add('gap');
        }
    }
    render() {
        return this.open
            ? html `
          <aside
            id="main"
            aria-label=${ifDefined(this.label || undefined)}
            aria-labelledby="${ifDefined(this.label ? undefined : 'title')}"
          >
            <div id="header">
              <slot id="title" name="label"><span>${this.label}</span></slot>
              <arc-icon-button
                id="toggleClose"
                name=${ICON_TYPES['arrow-left']}
                label="Close sidebar"
                @click=${this._handleClick}
              ></arc-icon-button>
            </div>
            <div id="content">
              <slot @slotchange=${this.handleSlots}></slot>
            </div>
          </aside>
        `
            : html `
          <arc-icon-button
            id="toggleOpen"
            name=${ICON_TYPES['arrow-right']}
            label="Open sidebar"
            @click=${this._handleClick}
          ></arc-icon-button>
        `;
    }
}
ArcSidebar.tag = 'arc-sidebar';
ArcSidebar.styles = styles;
__decorate([
    query('#content')
], ArcSidebar.prototype, "content", void 0);
__decorate([
    property({ type: Boolean, reflect: true })
], ArcSidebar.prototype, "open", void 0);
__decorate([
    property({ type: String })
], ArcSidebar.prototype, "label", void 0);
__decorate([
    watch('open', { waitUntilFirstUpdate: true })
], ArcSidebar.prototype, "handleOpenChange", null);
